export interface ConflictCheckActivity {
  id: string;
  venue: string | null;
  startTime: string;
  endTime: string;
}

function toMinutes(hhmm: string): number {
  if (!hhmm) return 0;
  const [h, m] = hhmm.split(':').map(Number);
  return (h ?? 0) * 60 + (m ?? 0);
}

/** Same venue overlap; exclusive endpoints; different rooms are not conflicts. */
export function detectConflicts(activities: ConflictCheckActivity[]): Set<string> {
  const flagged = new Set<string>();
  for (let i = 0; i < activities.length; i++) {
    for (let j = i + 1; j < activities.length; j++) {
      const a = activities[i];
      const b = activities[j];
      if (!a || !b) continue;
      if (!a.venue || !b.venue || a.venue !== b.venue) continue;
      const aS = toMinutes(a.startTime);
      const aE = toMinutes(a.endTime);
      const bS = toMinutes(b.startTime);
      const bE = toMinutes(b.endTime);
      if (aS < bE && bS < aE) {
        flagged.add(a.id);
        flagged.add(b.id);
      }
    }
  }
  return flagged;
}

export function findConflictWith(
  candidate: ConflictCheckActivity,
  others: ConflictCheckActivity[],
): ConflictCheckActivity | null {
  for (const other of others) {
    if (other.id === candidate.id) continue;
    if (!candidate.venue || !other.venue || candidate.venue !== other.venue) continue;
    const cS = toMinutes(candidate.startTime);
    const cE = toMinutes(candidate.endTime);
    const oS = toMinutes(other.startTime);
    const oE = toMinutes(other.endTime);
    if (cS < oE && oS < cE) return other;
  }
  return null;
}

export function toMinutesFromMidnight(hhmm: string): number {
  return toMinutes(hhmm);
}

export function durationMinutes(start: string, end: string): number {
  return toMinutes(end) - toMinutes(start);
}
